import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "row mt-2" }
const _hoisted_6 = { class: "col-md-12 table-responsive" }
const _hoisted_7 = { class: "table align-middle mb-0 table-hover" }
const _hoisted_8 = { class: "nowrap-celular" }
const _hoisted_9 = { class: "text-center text-nowrap" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "card-footer" }
const _hoisted_13 = { class: "row mt-2" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "col-md-2" }
const _hoisted_16 = { class: "row mb-2" }
const _hoisted_17 = { class: "col-md-12 fw-bold" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = {
  class: "col-md-12 table-responsive",
  style: {"max-height":"60vh","overflow-y":"auto"}
}
const _hoisted_20 = { class: "table table-sm table-hover align-middle mb-0" }
const _hoisted_21 = {
  key: 0,
  class: "text-muted text-center py-4"
}

import {onMounted, reactive, computed } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as service from "@/services/titularesService";

  //componentes
  import Paginador from "@/components/Paginador/Index.vue";
  import MsgBox from "@/components/MsgBox/Index.vue";
import { fdataHora } from "@/utils/funcoes";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  var controle = reactive({

    itens: [] as service.Titular[],


    status: "",
    erro: "",

    ordenacao: {
      coluna: '',
      asc: true
    },

    janVisualizar: false,
    itemVisualizar: null as service.Titular | null,
    linhasVisualizar: [] as string[][],
  })

  onMounted(async ()=>{
    
    pesquisar();
  })

  async function pesquisar() {

    service.obter()
    .then(r=> {
      controle.itens = r;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

  function ordenarPor(coluna: string) {
    if (controle.ordenacao.coluna === coluna) {
      controle.ordenacao.asc = !controle.ordenacao.asc;
    } else {
      controle.ordenacao.coluna = coluna;
      controle.ordenacao.asc = true;
    }
    controle.itens.sort((a, b) => {
      let valA = (a as Record<string, any>)[coluna];
      let valB = (b as Record<string, any>)[coluna];
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return controle.ordenacao.asc ? -1 : 1;
      if (valA > valB) return controle.ordenacao.asc ? 1 : -1;
      return 0;
    });
  }

    async function visualizar(item: service.Titular) {
      controle.erro = "";
      controle.itemVisualizar = item;
      controle.linhasVisualizar = [];
      controle.janVisualizar = true;

      service.obterPorId(item.id)
        .then(r => {
          const texto = r.conteudo || "";
          controle.linhasVisualizar = texto
            .split(/\r?\n/)
            .filter(linha => linha.trim() !== "")
            .map(linha => linha.split(";"));
        })
        .catch(erro => {
          controle.erro = erro;
          controle.janVisualizar = false;
        });
    }

    const cabecalhoVisualizar = computed(() => {
      if (controle.linhasVisualizar[0]?.length >= 5)
        return ["Nome", "Data Nascimento", "CPF", "ClienteId", "ContratoId"];
      return ["Nome", "Data Nascimento", "CPF"];
    });

    async function gerar() {

    service.gerar()
    .then(r=> {
      console.log(r);
      pesquisar();
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, { PageTitle: "Diário de Ativos" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              class: "btn btn-primary btn-sm mt-4 float-end",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (gerar()))
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "flaticon-play" }, null, -1),
              _createTextVNode(" Gerar", -1)
            ]))])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (ordenarPor('usuarioId'))),
                    class: "th-sortable"
                  }, "Id"),
                  _createElementVNode("th", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (ordenarPor('nomeCompleto'))),
                    class: "th-sortable"
                  }, "Data"),
                  _createElementVNode("th", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (ordenarPor('tipoId'))),
                    class: "th-sortable"
                  }, "Qtde"),
                  _cache[6] || (_cache[6] = _createElementVNode("th", null, "Opções", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, idx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: idx,
                    class: "align-middle"
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(fdataHora)(item.dataGeracao)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.qtde), 1),
                    _createElementVNode("td", _hoisted_9, [
                      _createElementVNode("a", {
                        class: "",
                        href: "javascript:void(0);",
                        title: "Visualizar",
                        onClick: ($event: any) => (visualizar(item))
                      }, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "flaticon-view" }, null, -1)
                      ]))], 8, _hoisted_10),
                      _createElementVNode("a", {
                        class: "ms-2",
                        href: "javascript:void(0);",
                        title: "Baixar arquivo",
                        onClick: ($event: any) => (service.download(item.id))
                      }, [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("i", { class: "flaticon-download-circular-button" }, null, -1)
                      ]))], 8, _hoisted_11)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(controle).itens.length) + " Registros ", 1),
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-md-4" }, null, -1)),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-secondary btn-sm float-end",
              to: '/'
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "flaticon-close" }, null, -1),
                _createTextVNode(" Fechar", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(MsgBox, {
      id: 'janVisualizar',
      titulo: 'Diário de Ativos',
      tamanho: 'modal-lg',
      exibir: _unref(controle).janVisualizar,
      onOnFechou: _cache[4] || (_cache[4] = ($event: any) => (_unref(controle).janVisualizar = false)),
      "botao-fechar": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(fdataHora)(_unref(controle).itemVisualizar?.dataGeracao)) + " — " + _toDisplayString(_unref(controle).itemVisualizar?.qtde) + " registro(s) ", 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("table", _hoisted_20, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cabecalhoVisualizar.value, (coluna, idx) => {
                    return (_openBlock(), _createElementBlock("th", { key: idx }, _toDisplayString(coluna), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).linhasVisualizar, (linha, idx) => {
                  return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linha, (valor, idx2) => {
                      return (_openBlock(), _createElementBlock("td", { key: idx2 }, _toDisplayString(valor), 1))
                    }), 128))
                  ]))
                }), 128))
              ])
            ]),
            (!_unref(controle).linhasVisualizar.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, " Nenhum registro neste arquivo. "))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})